import { JxtTagColorsEnum } from '@jooxter/utils';

export const alsoNowToneClasses: Record<JxtTagColorsEnum, { icon: string; reason: string }> = {
  [JxtTagColorsEnum.BLUE]: { icon: 'bg-primary-10 text-primary-110', reason: 'text-primary-140' },
  [JxtTagColorsEnum.ORANGE]: { icon: 'bg-orange-10 text-orange-110', reason: 'text-orange-140' },
  [JxtTagColorsEnum.RED]: { icon: 'bg-red-10 text-red-110', reason: 'text-red-140' },
  [JxtTagColorsEnum.GREEN]: { icon: 'bg-green-10 text-green-110', reason: 'text-green-140' },
  [JxtTagColorsEnum.NEUTRAL]: { icon: 'bg-neutral-10 text-neutral-110', reason: 'text-neutral-120' },
};
